import { API_URL } from './api/constant';
import { getRedirectUri } from './utility/helper';

export const msalConfig = {
  auth: {
    clientId: import.meta.env.VITE_AZURE_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${import.meta.env.VITE_AZURE_TENANT_ID}`,
    redirectUri: getRedirectUri(API_URL),
  },
};
export const loginRequest = {
  scopes: ['User.Read'],
};
